<template>
    <div class="bg-wrap">
        <div>
            <Banner></Banner>
        </div>
        <div class="content">
            <label class="title">请确定您的个人信息</label>
            <div class="input-wrap">
                <div class="item"  @click="slotShow(type=1)">
                    <span>省份</span>
                    <input type="text" v-model="judgeInfo.province" readonly>
                    <label class="select"></label>
                </div>
                <div class="item" @click="slotShow(type=2)">
                    <span>城市</span>
                    <input type="text" v-model="judgeInfo.city" readonly>
                    <label class="select"></label>
                </div>
                <div class="item">
                    <span>姓名</span>
                    <input type="text" v-model="judgeInfo.name">
                </div>
                <div class="item"  @click="toHospital">
                    <span>医院</span>
                    <input type="text" v-model="judgeInfo.hospital" readonly>
                    <label class="select"></label>
                </div>
                <div class="item"  @click="slotShow(type=3)">
                    <span>科室</span>
                    <input type="text" v-model="judgeInfo.dept" readonly>
                    <label class="select"></label>
                </div>
                <div class="item"  @click="slotShow(type=4)">
                    <span>职称</span>
                    <input type="text" v-model="judgeInfo.title" readonly>
                    <label class="select"></label>
                </div>
                <div class="item">
                    <span>专家手机号</span>
                    <input type="text" v-model="judgeInfo.phone">
                </div>
                <div class="hint">
                    <span>请务必填写正确</span>
                </div>
                <div class="submit" @click="toSubmit">
                    <span>提交</span>
                </div>
            </div>

            <mt-popup class="popup" v-model="popupVisible" popup-transition="popup-fade" closeOnClickModal="true"
                      position="bottom">
                <mt-picker :slots="slots" @change="slotValueChange" showToolbar>
                    <div class="picker-toolbar-title">
                        <div class="usi-btn-cancel" @click="popupVisible = !popupVisible">取消</div>
                        <div class="">请选择</div>
                        <div class="usi-btn-sure" @click="slotValueAdd">确定</div>
                    </div>
                </mt-picker>
            </mt-popup>

        </div>
    </div>

</template>

<script>
    import Banner from "@/components/ksd/fragment/Banner";
    import {ksdAddJudgeInfo,ksdAddress} from "@/assets/js/api";
    import {checkMobile} from "@/assets/util/util";

    export default {
        name: "JudgeLogin",
        data(){
            return{
                judgeInfo:{
                    province:"",
                    city:"",
                    hospital:"",
                    name:"",
                    hospitalLevel:"",
                    dept:"",
                    title:"",
                    phone:"",
                },
                popupVisible: false,
                slots: [
                    {
                        values: [],
                    }
                ],
                dept:[],
                title:[],
                slotSure:"",
                type:""
            }
        },
        components:{
            Banner
        },
        activated() {
            this.judgeInfo.hospital = localStorage.getItem("ksd_hospital")
            localStorage.removeItem("ksd_hospital")
        },
        methods:{
            slotValueChange(picker, values) {
                this.slotSure = values[0];
            },
            slotValueAdd() {
                this.popupVisible = !this.popupVisible
                switch (this.type) {
                    case 1:
                        this.judgeInfo.province = this.slotSure
                        this.judgeInfo.city=""
                        this.judgeInfo.hospital=""
                        break;
                    case 2:
                        this.judgeInfo.hospital=""
                        this.judgeInfo.city = this.slotSure
                        break;
                    case 3:
                        this.judgeInfo.dept = this.slotSure
                        break;
                    case 4:
                        this.judgeInfo.title = this.slotSure
                        break;
                }
            },
            slotShow() {
                switch (this.type) {
                    case 1: //省份
                        this.getAddress();
                        break;
                    case 2: //城市
                        if (this.judgeInfo.province == null || this.judgeInfo.province == "") {
                            this.$toast("请选择省份")
                            return;
                        }
                        this.getAddress(this.judgeInfo.province)
                        break;
                    case 3: //科室
                        this.slots[0].values = ['心内科', '肾内科', '神经内科','内分泌科','老年科','全科','其他']
                        break;
                    case 4: //职称
                        this.slots[0].values = ["主任医师", "副主任医师"]
                        break;
                }
                this.popupVisible = true
            },
            toHospital(){
                if(this.judgeInfo.city==null||this.judgeInfo.city==""){
                    this.$toast("请选择城市");
                    return
                }
                this.$router.push({path:"repAddress",query:{province:this.judgeInfo.province,city:this.judgeInfo.city}})
            },
            toSubmit(){
                if(this.judgeInfo.province==""){
                    this.$toast("请选择省份")
                    return;
                }
                if(this.judgeInfo.city==""){
                    this.$toast("请选择城市")
                    return;
                }
                if(this.judgeInfo.name==""){
                    this.$toast("请填写姓名")
                    return;
                }
                if(this.judgeInfo.hospital==""){
                    this.$toast("请选择医院")
                    return;
                }
                // if(this.judgeInfo.hospitalLevel==""){
                //     this.$toast("请选择医院级别")
                //     return;
                // }
                if(this.judgeInfo.dept==""){
                    this.$toast("请选择科室")
                    return;
                }
                if(this.judgeInfo.title==""){
                    this.$toast("请选择职称")
                    return;
                }
                if(this.judgeInfo.phone==""){
                    this.$toast("请填写手机号")
                    return;
                }
                if(!checkMobile(this.judgeInfo.phone)){
                    this.$toast("错误手机号")
                    return;
                }

                this.addInfo(this.judgeInfo.province,this.judgeInfo.city,this.judgeInfo.name,this.judgeInfo.hospital,this.judgeInfo.dept,this.judgeInfo.title,this.judgeInfo.phone)
            },
            async addInfo(province,city,name,hospital,dept,title,phone){
                const res = await ksdAddJudgeInfo({province,city,name,hospital,dept,title,phone})
                this.$toast(res.data.message)
                if(res.data.success){
                    setInterval(()=>{
                        location.reload()
                    },1000)
                }
            },
            async getAddress(province,city){
                const res = await  ksdAddress({province,city})
                if (res.data.success){
                    this.slots[0].values = res.data.data
                }
            }
        }

    }
</script>

<style scoped lang="scss">
    .bg-wrap {
        width: 100%;
        height: 100vh;
        background: transparent url("https://ymd-lcc.oss-cn-beijing.aliyuncs.com/ksd/bg.png") no-repeat;
        background-size: 100% 100%;
        display: flex;
        flex-flow: column;
        overflow: scroll;
    }
    .content{
        width: 100%;
        display: flex;
        flex-flow: column;
        justify-content: center;
        align-items: center;
        .input-wrap{
            width: 85%;
            margin: 0 auto;
        }
        .title{
            color: #156098;
            font-size: 20px;
            font-weight: bold;
            margin-bottom: 10px;
        }
        .item{
            background: #E6E6E6;
            text-align: left;
            height: 30px;
            font-size: 16px;
            border-radius: 5px;
            display: flex;
            flex-flow: row;
            align-items: center;
            margin-bottom: 8px;
            span{
                margin-left: 10px;
                white-space: nowrap;
            }
            input{
                flex-grow: 1;
                height: 100%;
                border: none;
                outline: none;
                text-indent: 10px;
                background: transparent;
                min-width: 10px;
            }
            .select{
                display: block;
                width: 8px;
                height: 8px;
                border-top: 1px #222 solid;
                border-right: 1px #222 solid;
                transform: rotate(45deg);
                margin-right: 10px;
            }
        }
        .hint{
            text-align: left;
            font-size: 10px;
            opacity: 0.8;
            margin-left: 10px;
        }
        .submit{
            background: #156098;
            color: #FFF;
            border-radius: 5px;
            margin: 10px;
            padding: 6px 0;
            font-size: 16px;
        }
    }

    .popup {
        width: 100%;
    }
    .picker-toolbar-title {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        height: 40px;
        line-height: 40px;
        font-size: 16px;
    }
    .usi-btn-cancel,
    .usi-btn-sure {
        color: #156098;
    }
    input{
        font-size: 16px;
    }

</style>